import { z } from 'zod'

export const batchUpdateExpensesSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(500),
  categoryId: z.string().guid(),
})

export type BatchUpdateExpensesDto = z.infer<typeof batchUpdateExpensesSchema>
